<template>
  <div id="order-management">
    <div class="search-wrapper">
      <!-- <div class="search">
        <span>订单号：</span>
        <Input style="width:120px;" v-model="searchValue.orderId"></Input>
      </div> -->
      <div class="search">
        <span>项目编号：</span>
        <Input style="width:150px;" v-model="searchValue.projectNum"></Input>
      </div>
      <div class="search">
        <span>项目简编：</span>
        <Input style="width:150px;" v-model="searchValue.projectNumShort"></Input>
      </div>
      <div class="search">
        <span>单位名称：</span>
        <Input style="width:150px;" v-model="searchValue.orderCompany"></Input>
      </div>
      <div class="search">
        <span>状态：</span>
        <Select style="width:80px;" v-model="searchValue.orderStatus">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input v-model="searchValue.amount[0]" style="width:80px;margin-right:5px;"></Input>
        <span> - </span>
        <Input v-model="searchValue.amount[1]" style="width:80px;margin-right:5px;"></Input>
      </div>
      <div class="search">
        <span>收/退款时间：</span>
        <DatePicker v-model="searchValue.payTime" type="daterange" placement="bottom-end" style="width: 150px;margin-right:5px"></DatePicker>
      </div>
      <!-- <div class="search">
        <span>借贷：</span>
        <Select style="width:80px;" v-model="searchValue.feeType">
          <Option v-for="item in feeTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div> -->
      <div class="search">
        <span>支付方式：</span>
        <Input v-model="searchValue.payType" style="width:120px"></Input>
      </div>
      <div class="search">
        <span>订单类型：</span>
        <Select disabled style="width:100px;" v-model="searchValue.orderType">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search">
        <span>可否线上退保：</span>
        <Select style="width:100px;" v-model="searchValue.canOnline">
          <Option :value="1" :key="1">可退</Option>
          <Option :value="2" :key="2">不可退</Option>
          <Option :value="0" :key="0">全部</Option>
        </Select>
      </div>
      <div class="search">
        <span>是否已线上退保：</span>
        <Select style="width:100px;" v-model="searchValue.hasOnlineRefund">
          <Option :value="1" :key="1">是</Option>
          <Option :value="2" :key="2">否</Option>
          <Option :value="0" :key="0">全部</Option>
        </Select>
      </div>
      <Button type="primary" icon="ios-search" style="margin: 0 10px 0 10px;" @click="searchOrder">搜索</Button>
      <Button type="success" @click="viewReport('receive')" style="margin-right:5px">收保证金一览</Button>
      <Button type="success" @click="viewReport('back')" style="margin-right:5px">退保证金一览</Button>
      <Button type="success" @click="exportExcel" style="margin-right:5px">导出</Button>
      <Button type="success" @click="viewReport('marginAccount')" style="margin-right:5px">保证金台账</Button>
      <Button type="info" @click="batchRefund">批量退保</Button>
    </div>
    <Table @on-selection-change="selectionChange" :columns="ordersColumns" :data="ordersList" style="min-width:1400px;"></Table>
    <Page ref="page" :current="currentPage" style="margin-top:10px;" :total="totalOrders" show-elevator show-total @on-change="changePage"></Page>
    <!-- 退保填写 -->
    <Modal title="退保证金" v-model="refundDepositVisible" width="600px" class="refund-modal">
      <Form :label-width="110" inline>
        <FormItem label="保证金退还金额" required>
          <Input style="width:120px;" v-model="refundDepositForm.amount"></Input>
        </FormItem>
        <FormItem label="退款日期" :label-width="80">
          <DatePicker v-model="refundDepositForm.date" type="date" style="width: 120px"></DatePicker>
        </FormItem>
        <FormItem label="保证金退款方式" required>
          <Select v-model="refundDepositForm.refundType" style="width:120px">
            <Option v-for="item in refundTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="退保证金OA单号" required :label-width="120">
          <Input style="width:120px;" v-model="refundDepositForm.oaNumber"></Input>
        </FormItem>
        <FormItem label="迟退或未退原因">
          <Input v-model="refundDepositForm.reason" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="备注">
          <Input style="width:300px;" v-model="refundDepositForm.comment"></Input>
        </FormItem>
        <FormItem label="退保户名">
          <Input :disabled="isRefundDetail" style="width:300px;" v-model="refundDepositForm.companyName"></Input>
        </FormItem>
        <FormItem label="退保账号">
          <Input :disabled="isRefundDetail" style="width:300px;" v-model="refundDepositForm.companyAccount"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="refundDepositVisible=false">取消</Button>
        <Button type="primary" @click="submitRefund" v-if="confirmPermission">确定</Button>
      </div>
    </Modal>
    <!-- 线上退报填写 -->
    <Modal title="线上退保" v-model="onlineRefundVisible" width="800" class="refund-modal">
      <template v-if="selectDeposit.clMargin">
        <div style="font-size:14px;">保证金账号：<span style="color:#19be6b;">{{selectDeposit.clMargin.subsidiaryAccount}}</span></div>
        <div style="font-size:14px;">
          <div style="display:inline-block;width:350px;">
            <div>汇款金额：<span style="color:#19be6b;">{{selectDeposit.clMargin.amount}}</span></div>
            <div>汇款账号名称：<span style="color:#19be6b;">{{selectDeposit.clMargin.ghfAccountName}}</span></div>
            <!-- <div>汇款银行名称：<span>{{selectDeposit.clMargin.amount}}</span></div> -->
            <div>汇款银行账号：<span style="color:#19be6b;">{{selectDeposit.clMargin.ghfAccount}}</span></div>
          </div>
          <div style="display:inline-block;width:350px;">
            <div>退款金额：<span style="color:#ed4014;">{{selectDeposit.orderAmountTotal}}</span></div>
            <div>退款账号名称：<span style="color:#ed4014;">{{selectDeposit.abpOrdersExp.bankName}}</span></div>
            <!-- <div>退款银行名称：<span>{{}}</span></div> -->
            <div>退款银行账号：<span style="color:#ed4014;">{{selectDeposit.abpOrdersExp.bankAccount}}</span></div>
          </div>
        </div>
      </template>
      <!-- <Form :label-width="110" inline style="margin-top:10px;">
        <FormItem label="是否计算利息">
          <Select v-model="onlineRefundForm.isInterest" style="width:150px;" :disabled="!!selectDeposit.abpRefundLog">
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem label="退款类型">
          <Select v-model="onlineRefundForm.refundType" style="width:150px;" disabled>
            <Option value="2">原路退回</Option>
            <Option value="1">非原路退回</Option>
          </Select>
        </FormItem>
      </Form> -->
      <div slot="footer">
        <Button @click="onlineRefundVisible=false">取消</Button>
        <Button type="primary" @click="createOnlineRefund" :disabled="!!selectDeposit.abpRefundLog">发起退款</Button>
      </div>
    </Modal>
    <!-- 导出类型 -->
    <Modal title="导出类型" v-model="exportVisible">
      <Select v-model="exportType">
        <Option value="保证金">领保证金</Option>
        <Option value="退保证金">退保证金</Option>
      </Select>
      <div slot="footer">
        <Button @click="exportVisible=false">取消</Button>
        <Button type="primary" @click="exportDepoist">确定</Button>
      </div>
    </Modal>
    <!-- 批量线上退保 -->
    <Modal title="批量线上退保" v-model="batchRefundVisible" width="1100" class-name="batch-refund">
      <div v-for="(refundItem, index) in batchSelection" :key="index" class="batch-item">
        <div style="font-size:14px;">保证金账号：<span style="color:#19be6b;">{{refundItem.clMargin.subsidiaryAccount}}</span></div>
        <div style="font-size:14px;">
          <span>项目编号：<span style="color:#19be6b;">{{refundItem.clProjectDb.projectFull}}</span></span>
          <span style="margin-left:10px;">所投包组：<span style="color:#19be6b;">{{refundItem.abpOrdersExp.clGroupDb.groupNo}}</span></span>
        </div>
        <div style="font-size:14px;">
          <div style="display:inline-block;width:350px;">
            <div>汇款金额：<span style="color:#19be6b;">{{refundItem.clMargin.amount}}</span></div>
            <div>汇款账号名称：<span style="color:#19be6b;">{{refundItem.clMargin.ghfAccountName}}</span></div>
            <!-- <div>汇款银行名称：<span>{{selectDeposit.clMargin.amount}}</span></div> -->
            <div>汇款银行账号：<span style="color:#19be6b;">{{refundItem.clMargin.ghfAccount}}</span></div>
          </div>
          <div style="display:inline-block;width:350px;">
            <div>退款金额：<span style="color:#ed4014;">{{refundItem.orderAmountTotal}}</span></div>
            <div>退款账号名称：<span style="color:#ed4014;">{{refundItem.abpOrdersExp.bankName}}</span></div>
            <!-- <div>退款银行名称：<span>{{}}</span></div> -->
            <div>退款银行账号：<span style="color:#ed4014;">{{refundItem.abpOrdersExp.bankAccount}}</span></div>
          </div>
          <!-- <div style="display:inline-block;width:300px;">
            <Form :label-width="110" inline style="margin-top:10px;">
              <FormItem label="是否计算利息">
                <Select v-model="refundItem.isInterest" style="width:150px;" :disabled="!!selectDeposit.abpRefundLog">
                  <Option value="1">是</Option>
                  <Option value="0">否</Option>
                </Select>
              </FormItem>
              <FormItem label="退款类型">
                <Select v-model="refundItem.refundType" style="width:150px;" disabled>
                  <Option value="2">原路退回</Option>
                  <Option value="1">非原路退回</Option>
                </Select>
              </FormItem>
            </Form>
          </div> -->
        </div>
      </div>
      <div slot="footer">
        <Button>取消</Button>
        <Button type="primary" @click="batchRefundConfirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '../../lib/ajax'
import invoice from '../../components/invoice'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'
import { Tooltip, Icon } from 'iview'
import axios from 'axios'
import url from '@/lib/url'

const unlimitedAjax =  axios.create({
  baseURL: url,
})
unlimitedAjax.interceptors.request.use(config => {
  if (!!window.abp.auth.getToken()) {
		config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
	}
	config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
	config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
	return config;
})

export default {
  name: 'ordersManagement',
  data() {
    return {
      fileUrl: '',
      fileName: 'excel',
      refundDepositVisible: false,
      isRefundDetail: false,
      refundDepositForm: {
        amount: '',
        date: '',
        day: '',
        refundType: '工商银行',
        oaNumber: '',
        reason: '',
        comment: '',
        companyName: '',
        companyAccount: ''
      },
      refundTypes: [
        {
          value: '工商银行',
          label: '工商银行'
        },
        {
          value: '兴业银行',
          label: '兴业银行'
        },
        {
          value: '建设银行',
          label: '建设银行'
        },
        {
          value: '光大银行',
          label: '光大银行'
        },
        {
          value: '广发银行',
          label: '广发银行'
        },
        {
          value: '农业银行',
          label: '农业银行'
        },
        {
          value: '惠州工商银行',
          label: '惠州工商银行'
        },
        {
          value: '茂名工商银行',
          label: '茂名工商银行'
        },
        {
          value: '清远工商银行',
          label: '清远工商银行'
        },
        {
          value: '云浮工商银行',
          label: '云浮工商银行'
        },
        {
          value: '湛江工商银行',
          label: '湛江工商银行'
        },
        {
          value: '阳江工商银行',
          label: '阳江工商银行'
        },
        {
          value: '河源广发银行',
          label: '河源广发银行'
        },
        {
          value: '清远广发银行',
          label: '清远广发银行'
        },
        {
          value: '惠州广发银行',
          label: '惠州广发银行'
        },
        {
          value: '茂名广发银行',
          label: '茂名广发银行'
        },
        {
          value: '云浮广发银行',
          label: '云浮广发银行'
        },
        {
          value: '湛江广发银行',
          label: '湛江广发银行'
        },
        {
          value: '阳江广发银行',
          label: '阳江广发银行'
        },
        {
          value: '揭阳广发银行',
          label: '揭阳广发银行'
        },
        {
          value: '四川广发银行',
          label: '四川广发银行'
        },
        {
          value: '佛山广发银行',
          label: '佛山广发银行'
        },
        {
          value: '珠海广发银行',
          label: '珠海广发银行'
        },
        {
          value: '肇庆广发银行',
          label: '肇庆广发银行'
        },
        {
          value: '汕尾广发银行',
          label: '汕尾广发银行'
        },
        {
          value: '韶关广发银行',
          label: '韶关广发银行'
        },
        {
          value: '江门广发银行',
          label: '江门广发银行'
        },
        {
          value: '深圳交通银行',
          label: '深圳交通银行'
        },
        {
          value: '交通银行',
          label: '交通银行'
        },
        {
          value: '渤海银行',
          label: '渤海银行'
        },
        {
          value: '浦发银行',
          label: '浦发银行'
        },
        {
          value: '军工广发银行',
          label: '军工广发银行'
        },
        {
          value: '邮政储蓄银行',
          label: '邮政储蓄银行'
        }
      ],
      confirmPermission: true,
      ordersColumns: [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },
        {
          title: '单位',
          key: 'ghfCompanyName'
        },
        {
          title: '项目编号',
          width: 150,
          key: 'projectFull'
        },
        {
          title: '包组',
          width: 60,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '应收保证金',
          width: 100,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.marginAmount)
          }
        },
        {
          title: '收/退金额',
          key: 'orderAmountTotal',
          width: 90
        },
        // {
        //   title: '借贷',
        //   key: 'debitAndCredit',
        //   width: 60
        // },
        {
          title: '订单类型',
          key: 'orderType',
          width: 90,
          render: (h,params) => {
            return params.row.orderType == '保证金' ? h('div','收保证金') : h('div',params.row.orderType)
          }
        },
        {
          title: '状态',
          width: 60,
          render: (h, params) => {
            let status = '/'
            let statusColor = '#000'
            switch (params.row.orderStatus) {
              case '0':
                status = '退保'
                statusColor = '#2d8cf0'
                break
              case '2':
                status = '未退'
                statusColor = '#ff9900'
                break
              case '4':
                status = '已退'
                statusColor = '#19be6b'
                break
            }
            return h('div', {
              style: {
                color: statusColor
              }
            }, status)
          }
        },
        {
          title: '收/退时间',
          width: 100,
          render: (h, params) => {
            let time = ''
            if (!!params.row.payTime) {
              time = params.row.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '支付方式',
          width: 90,
          render: (h, params) => {
            let payChannel = '无'
            if (!!params.row.payChannel) {
              payChannel = params.row.payChannel
            }
            return h('div', payChannel)
          }
        },
        {
          title: '确认人',
          key: 'confirm',
          width: 75
        },
        {
          title: '线上退保',
          width: 85,
          render: (h, params) => {
            let canOnline = '不可退'
            if (params.row.orderStatus == 0 && params.row.clMargin && params.row.clMargin.subsidiaryAccount && params.row.clMargin.amount === params.row.orderAmountTotal) {
              canOnline = '可退'
            }
            if (params.row.orderStatus != 0) {
              canOnline = '非退保'
            }
            return h('div', canOnline)
          }
        },
        {
          title: '状态(线上退)',
          width: 110,
          render: (h, params) => {
            let onlineStatus = '无'
            if (params.row.abpRefundLog && params.row.abpRefundLog.status) {
              onlineStatus = params.row.abpRefundLog.status
              return (
                <div>
                  <span>{onlineStatus}</span>
                  <Tooltip placement="top" content={params.row.abpRefundLog.word}>
                    <Icon type="ios-information-outline" style="color:#ff9900;font-size:14px;margin-left:3px;"></Icon>
                  </Tooltip>
                </div>
              )
            } else {
              return h('div', onlineStatus)
            }
          }
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            let resultArray = []
            let operateArray = [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: params.row.orderStatus !== '2'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.refundDeposit(params.row)
                  }
                }
              }, '退保证金'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: !!params.row.abpRefundLog
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                  marginBottom: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.flowStatus === '1' || params.row.flowStatus === '2') {
                      this.$Message.info('已发起流程，不可删除。请先删除退保流程申请。')
                      return
                    }
                    if (params.row.abpRefundLog) {
                      this.$Message.error('已发起线上退保，不可删除')
                      return
                    }
                    this.deleteDeposit(params.row)
                  }
                }
              }, '删除'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.reDepositDetail(params.row)
                  }
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
              }, '详情'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !(params.row.orderStatus == 0 && params.row.clMargin && params.row.clMargin.subsidiaryAccount && params.row.clMargin.amount === params.row.orderAmountTotal)
                },
                on: {
                  click: () => {
                    if (!this.onlinePermission) {
                      this.$Message.error('无权限')
                      return
                    }
                    if (params.row.clMargin.subsidiaryAccount.indexOf('955088000') > -1) {
                      this.$Message.error('旧版保证金账号已作废，不可进行线上退保操作')
                      return
                    }
                    if (!(params.row.orderStatus == 0 && params.row.clMargin && params.row.clMargin.subsidiaryAccount && params.row.clMargin.amount === params.row.orderAmountTotal)) {
                      this.$Message.error('不可线上退')
                      return
                    }
                    // this.reDepositDetail(params.row)
                    this.selectDeposit = params.row

                    if (params.row.abpRefundLog && params.row.abpRefundLog.interest) {
                      this.onlineRefundForm.isInterest = params.row.abpRefundLog.interest
                    }

                    this.onlineRefundVisible = true
                  }
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
              }, '线上退保'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !params.row.abpRefundLog
                },
                on: {
                  click: async () => {
                    // this.reDepositDetail(params.row)
                    let rep = await ajax.post(requestUrls.ClMargin.RefundStatus + `?ordersId=${params.row.id}`)
                    if (rep.data.success) {
                      this.$Message.success('更新成功')
                      this.getOrders(this.currentPage, this.searchValue)
                    }
                  }
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                  marginBottom: '5px'
                },
              }, '更新状态'),
            ]
            if (params.row.orderType === '保证金') {
              resultArray.push(operateArray[0])
            }
            if (params.row.orderType === '退保证金') {
              resultArray.push(operateArray[2], operateArray[3], operateArray[4], operateArray[1])
            }
            // 未退可删
            if (params.row.orderStatus === '2') {
              resultArray.push(operateArray[1])
            }
            return h('div', resultArray)
          }
        }

      ],
      ordersList: [],
      totalOrders: 0,
      searchValue: {
        // orderId: '',
        orderCompany: '',
        orderStatus: '',
        orderType: '保证金',
        payType: '',
        projectNum: '',
        projectNumShort: '',
        amount: ['', ''],
        payTime: [],
        canOnline: '',
        hasOnlineRefund: ''
      },
      // makeInvoiceVisible: false,
      statusList: [
        {
          value: '0',
          label: '退保'
        },
        {
          value: '2',
          label: '未退'
        },
        {
          value: '4',
          label: '已退'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      typeList: [
        {
          value: '报名',
          label: '报名'
        },
        {
          value: '保证金',
          label: '保证金'
        },
        {
          value: '服务费',
          label: '服务费'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      feeTypeList: [
        {
          value: '借',
          label: '借'
        },
        {
          value: '贷',
          label: '贷'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      invoiceData: {},
      currentPage: 1,
      selectDeposit: {},
      exportVisible: false,
      exportType: '保证金',
      onlineRefundVisible: false,
      onlineRefundForm: {
        isInterest: '0',
        refundType: '2',
      },
      batchSelection: [],
      batchRefundVisible: false
    }
  },
  created() {
    this.getOrders(1, this.searchValue)
  },
  computed: {
    onlinePermission() {
      // 获取用户角色信息
      return this.$store.getters["session/hasRoles"]("线上退保")
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'ordersManagement') {
        this.getOrders(this.currentPage, this.searchValue)
      }
    }
  },
  methods: {
    async getOrders(page, { orderId, orderCompany, orderStatus, orderType, feeType, payType, projectNum, projectNumShort, payTime, amount, canOnline, hasOnlineRefund }) {
      this.currentPage = page
      let dbSearOrderId = !orderId ? '' : ` and orderNo.Contains("${orderId}")`
      let dbSearOrderCompany = !orderCompany ? '' : ` and ghfCompanyName.Contains("${orderCompany}")`
      let dbSearOrderStatus = !orderStatus ? '' : ` and orderStatus == "${orderStatus}"`
      let dbSearOrderType = !orderType ? '' : ` and orderType.contains("${orderType}")`
      let dbSearFeeType = !feeType ? '' : ` and debitAndCredit == "${feeType}"`
      let dbSearPayType = !payType ? '' : ` and payChannel.contains("${payType}")`
      let dbSearProjectNum = !projectNum ? '' : ` and clProjectDb.projectFull.contains("${projectNum}")`
      let dbSearProjectNumShort = !projectNumShort ? '' : ` and clProjectDb.projectShort.contains("${projectNumShort}")`
      let amountLowerSear = (amount[0] || parseInt(amount[0]) === 0) ? ` and orderAmountTotal >= "${amount[0]}"` : ''
      let amountUpperSear = (amount[1] || parseInt(amount[1]) === 0) ? ` and orderAmountTotal <= "${amount[1]}"` : ''
      let start = ''
      let end = ''
      if (payTime[0] && payTime[1]) {
        start = formatDate(payTime[0]).split(' ')[0]
        end = formatDate(payTime[1]).split(' ')[0]
      }
      let dbSearPayTime = (start && end) ? ` and payTime >= "${start}" and payTime <= "${end}"` : ''

      let dbSearCanOnline = canOnline ? (canOnline === 1 ? ' and (orderStatus == "0" and clMargin.subsidiaryAccount != null and clMargin.amount == orderAmountTotal)' : ' and (orderStatus == "0" and (clMargin.subsidiaryAccount == null or clMargin.amount != orderAmountTotal))') : ''
      let dbSearHasOnlineRefund = hasOnlineRefund ? (hasOnlineRefund === 1 ? ' and (orderStatus == "0" and abpRefundLog != null and abpRefundLog.status != null)' : ' and (orderStatus == "0" and (abpRefundLog == null or abpRefundLog.status == null))') : ''

      let filterData = dbSearOrderId + dbSearOrderCompany + dbSearOrderStatus + dbSearOrderType + dbSearFeeType + dbSearPayType + dbSearProjectNum + dbSearPayTime + amountLowerSear + amountUpperSear + dbSearProjectNumShort + dbSearCanOnline + dbSearHasOnlineRefund
      
      // filterData += ' and clMargin.reciprocalOpenAccount != null'
      
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
          filter: filterData.slice(5),
          sorting: 'creationTime desc'
        }
      })
      if (rep.data.success) {
        // this.ordersList = rep.data.result.items
        this.ordersList = []
        rep.data.result.items.forEach(item => {
          if (item.orderStatus != 0 || !item.clMargin || !item.clMargin.subsidiaryAccount || item.clMargin.amount !== item.orderAmountTotal || item.abpRefundLog) {
            item._disabled = true
          } else {
            item.isInterest = '0'
            item.refundType = '2'
          }
          this.ordersList.push(item)
        })
        this.totalOrders = rep.data.result.totalCount
      }
    },
    changePage(page) {
      this.getOrders(page, this.searchValue)
    },
    searchOrder() {
      this.getOrders(1, this.searchValue)
    },
    submitRefund() {
      if (this.refundDepositForm.amount === '') {
        this.$Message.error('金额不能为空')
        return
      }
      if (this.refundDepositForm.refundType === '') {
        this.$Message.error('退款方式不能为空')
        return
      }
      if (this.refundDepositForm.oaNumber === '') {
        this.$Message.error('OA单号不能为空')
        return
      }
      if (!this.isRefundDetail) {
        this.$Modal.confirm({
          title: '退保证金',
          content: '确认退此保证金？',
          onOk: async () => {
            this.$Spin.show()
            try {
              if (this.refundDepositForm.date) {
                this.refundDepositForm.date = formatDate(this.refundDepositForm.date)
              }
              let rep = await ajax.post(requestUrls.order.CreateRefund, {
                amount: this.refundDepositForm.amount,
                refundOA: this.refundDepositForm.oaNumber,
                orderMethod: this.refundDepositForm.refundType,
                numberDay: this.refundDepositForm.day,
                OrderPayTime: this.refundDepositForm.date,
                comment: this.refundDepositForm.comment,
                cause: this.refundDepositForm.reason,
                accountName: this.refundDepositForm.companyName,
                // bankName: this.refundDepositForm.companyName,
                bankAccount: this.refundDepositForm.companyAccount,
                marginDetailId: this.selectDeposit.clMarginId,
                orderNo: this.selectDeposit.orderNo,
                orderConfirm: this.$store.state.session.user.name,
                ordersExp: {
                  bankName: this.refundDepositForm.companyName,
                  bankAccount: this.refundDepositForm.companyAccount,
                  projectId: this.selectDeposit.abpOrdersExp.projectId,
                  groupId: this.selectDeposit.abpOrdersExp.groupId,
                  groupName: this.selectDeposit.abpOrdersExp.groupName
                }
              })
              this.$Spin.hide()
              if (rep.data.success) {
                // 修改原订单状态
                ajax.put(requestUrls.order.updateOrder, {
                  id: this.selectDeposit.id,
                  orderStatus: '4'
                })
                this.$Message.success('退保成功')
                this.selectDeposit.orderStatus = '4'
                this.refundDepositVisible = false
                this.getOrders(this.currentPage, this.searchValue)
              } else {
                this.$Message.error('退保失败')
              }
            } catch (err) {
              console.error(err)
              this.$Spin.hide()
              this.$Message.error('退保失败')
            }
          }
        })
      } else {
        this.$Modal.confirm({
          title: '退保证金',
          content: '确认修改此退保证金？',
          onOk: async () => {
            this.$Spin.show()
            try {
              // 修改退保信息
              let refundRep = await ajax.post(requestUrls.AbpRefundMargin.CreateOrUpdate, {
                abpRefundMargin: {
                  id: this.selectDeposit.abpRefundMarginId,
                  amount: this.refundDepositForm.amount,
                  refundOA: this.refundDepositForm.oaNumber,
                  numberDay: this.refundDepositForm.day,
                  comment: this.refundDepositForm.comment,
                  cause: this.refundDepositForm.reason,
                  orderMethod: '',
                  bankName: '',
                  bankAccount: '',
                  marginDetailId: '',
                  orderPayTime: ''
                }
              })
              // 修改订单时间
              let date = ''
              if (this.refundDepositForm.date) {
                date = formatDate(this.refundDepositForm.date)
              }
              let rep = await ajax.put(requestUrls.order.updateOrdersPay, {
                id: this.selectDeposit.id,
                payChannel: this.refundDepositForm.refundType,
                payTime: date,
                orderAmountTotal: this.refundDepositForm.amount
              })

              if (rep.data.success) {
                // 修改应标退保时间
                // this.selectDeposit.ybId
                let ybRep = await ajax.post(requestUrls.YbDb.CreateOrUpdate, {
                  YbDb: {
                    id: this.selectDeposit.ybId,
                    refundTime: date
                  }
                })
                this.$Spin.hide()
                this.$Message.success('修改成功')
                this.getOrders(this.currentPage, this.searchValue)
              } else {
                this.$Spin.hide()
                this.$Message.error('修改失败')
              }
            } catch (err) {
              console.error(err)
              this.$Spin.hide()
              this.$Message.error('修改失败')
            }
          }
        })
      }
    },
    refundDeposit(deposit) {
      this.selectDeposit = deposit
      this.isRefundDetail = false
      this.refundDepositVisible = true
      this.refundDepositForm.amount = this.selectDeposit.orderAmountTotal
      this.refundDepositForm.companyName = this.selectDeposit.abpOrdersExp.bankName
      this.refundDepositForm.companyAccount = this.selectDeposit.abpOrdersExp.bankAccount
      this.refundDepositForm.date = ''
      this.refundDepositForm.oaNumber = ''
      this.refundDepositForm.refundType = this.selectDeposit.payChannel
      this.refundDepositForm.day = ''
      this.refundDepositForm.comment = ''
      this.refundDepositForm.reason = ''
    },
    async reDepositDetail(deposit) {
      this.selectDeposit = deposit
      this.isRefundDetail = true
      // this.refundDepositVisible = true
      // 获取退保订单
      this.$Spin.show()
      try {
        let rep = await ajax.get(requestUrls.AbpRefundMargin.GetById, {
          params: {
            id: deposit.abpRefundMarginId
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.refundDetailData = rep.data.result
          let refund = rep.data.result
          this.refundDepositVisible = true
          this.refundDepositForm.amount = refund.amount
          this.refundDepositForm.companyName = deposit.abpOrdersExp.bankName
          this.refundDepositForm.companyAccount = deposit.abpOrdersExp.bankAccount
          this.refundDepositForm.date = ''
          if (this.selectDeposit.payTime) {
            this.refundDepositForm.date = this.selectDeposit.payTime.split('T')[0]
          }
          this.refundDepositForm.oaNumber = refund.refundOA
          this.refundDepositForm.refundType = this.selectDeposit.payChannel
          this.refundDepositForm.day = refund.numberDay
          this.refundDepositForm.comment = refund.comment
          this.refundDepositForm.reason = refund.cause
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('查询失败')
      }
    },
    async createOnlineRefund() {
      if (!this.onlinePermission) {
        this.$Message.error('无权限')
        return
      }
      if (this.selectDeposit.clMargin.subsidiaryAccount.indexOf('955088000') > -1) {
        this.$Message.error('旧版保证金账号已作废，不可进行线上退保操作')
        return
      }
      if (this.selectDeposit.abpRefundLog) {
        this.$Message.error('已发起退保，不可再次发起')
        return
      }
      if (this.onlineRefundForm.isInterest === '' || this.onlineRefundForm.refundType === '') {
        this.$Message.error('请选择是否计息')
        return
      }
      this.$Modal.confirm({
        title: '发起线上退款',
        content: '确认发起线上退款，发起退款后款项直接退还，请仔细确认',
        onOk: async () => {
          this.$Spin.show()
          try {
            // 修改退保信息
            let rep = await ajax.post(requestUrls.AbpRefundMargin.GfCreateOrUpdate, {
              id: this.selectDeposit.abpRefundMarginId,
              accountName: this.selectDeposit.clMargin.ghfAccountName,
              bankName: this.selectDeposit.clMargin.reciprocalOpenAccount,
              bankAccount: this.selectDeposit.clMargin.ghfAccount,
              isInterest: this.onlineRefundForm.isInterest,
              refundType: this.onlineRefundForm.refundType,
              projectId: this.selectDeposit.projectId,
              marginDetailId: this.selectDeposit.clMarginId,
              ordersId: this.selectDeposit.id,
              companyName: this.selectDeposit.ghfCompanyName
            })
            if (rep.data.success) {
              // 发起退款
              await ajax.post(requestUrls.ClMargin.MarginRefund + `?orderId=${this.selectDeposit.id}`)
              this.$Spin.hide()
              this.$Message.success('已发起退款')
              this.onlineRefundVisible = false
              this.getOrders(this.currentPage, this.searchValue)
            } else {
              this.$Spin.hide()
              this.$Message.error('发起退款失败')
              this.onlineRefundVisible = false
            }
          } catch(err) {
            this.$Spin.hide()
            this.$Message.error('发起退款失败')
            console.error(err)
            this.onlineRefundVisible = false
          }
        }
      })
      
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', text)
          ])
        }
      })
    },
    exportExcel() {
      let search = this.searchValue
      if (search.orderCompany === '' && search.orderStatus === '' && search.projectNum === '' && search.amount[0] === '' && search.amount[1] === '' && search.payTime[0] === '' && search.payTime[1] === '') {
        this.$Message.error('最少一个筛选条件')
        return
      }
      this.exportVisible = true
    },
    exportDepoist() {
      let search = this.searchValue
      let dbSearOrderCompany = !search.orderCompany ? '' : ` and ghfCompanyName.Contains("${search.orderCompany}")`
      let dbSearOrderStatus = !search.orderStatus ? '' : ` and orderStatus == "${search.orderStatus}"`
      // let dbSearOrderType = !search.orderType ? '' : ` and orderType.contains("${search.orderType}")`
      let dbSearFeeType = !search.feeType ? '' : ` and debitAndCredit == "${search.feeType}"`
      let dbSearPayType = !search.payType ? '' : ` and payChannel.contains("${search.payType}")`
      let dbSearProjectNum = !search.projectNum ? '' : ` and projectFull.contains("${search.projectNum}")`
      let amountLowerSear = (search.amount[0] || parseInt(search.amount[0]) === 0) ? ` and orderAmountTotal >= "${search.amount[0]}"` : ''
      let amountUpperSear = (search.amount[1] || parseInt(search.amount[1]) === 0) ? ` and orderAmountTotal <= "${search.amount[1]}"` : ''
      let start = ''
      let end = ''
      if (search.payTime[0] && search.payTime[1]) {
        start = formatDate(search.payTime[0]).split(' ')[0]
        end = formatDate(search.payTime[1]).split(' ')[0]
      }
      let dbSearPayTime = (start && end) ? ` and payTime >= "${start}" and payTime <= "${end}"` : ''

      let filterData = dbSearOrderCompany + dbSearOrderStatus + dbSearFeeType + dbSearPayType + dbSearProjectNum + dbSearPayTime + amountLowerSear + amountUpperSear
      filterData = filterData.slice(5)

      let exportType = 2
      if (this.exportType === '退保证金') {
        exportType = 1
      }

      this.$Modal.confirm({
        title: '导出',
        content: '确定导出Excel数据',
        onOk: async () => {
          window.open(`${url}${requestUrls.Export.ExportOrderResult}?filter=${filterData}&sorting="payTime desc"&exportType=${exportType}`)
          this.exportVisible = false
        }
      })
    },
    viewReport(type) {
      if (type === 'receive') {
        window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%2FSBond.cpt&op=write`)
      }
      if (type === 'back') {
        window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%2FTBond.cpt&op=write`)
      }
      if (type === 'marginAccount') {
        window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D.cpt`)
      }
    },
    deleteDeposit(deposit) {
      this.$Modal.confirm({
        title: '删除领取信息',
        content: `确定删除单位 ${deposit.ghfCompanyName} 此保证金信息？(此操作不可撤回)`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.delete(requestUrls.order.Delete, {
              params: {
                id: deposit.id
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('删除成功')
              // 删除成功更新对应原数据状态
              // 修改保证金订单状态
              if (deposit.orderType === '退保证金') {
                ajax.put(requestUrls.order.UpdateOrdersByNumber, {
                  orderNo: deposit.redOrderNo,
                  orderStatus: '2',
                  flowStatus: '0'
                })
              }
              // 修改认领保证金状态
              if (deposit.orderType === '保证金') {
                // 查询原领取订单数
                let orderRep = await ajax.get(requestUrls.order.getPaged, {
                  params: {
                    filter: `clMarginId=="${deposit.clMarginId}"`,
                    maxResultCount: 5,
                    skipCount: 0,
                  }
                })
                if (orderRep.data.result.items.length === 0) {
                  ajax.put(requestUrls.ClMargin.UpdateMarginStatus, {
                    id: deposit.clMarginId,
                    state: '0'
                  })
                }
              }
              // 刷新当前订单
              this.getOrders(this.currentPage, this.searchValue)
            } else {
              this.$Message.error('删除失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('删除失败')
          }
        }
      })
    },
    batchRefund() {
      if (!this.onlinePermission) {
        this.$Message.error('无权限')
        return
      }
      if (this.batchSelection.length === 0) {
        this.$Message.info('请至少选择一个线上退保')
        return
      }
      console.log(this.batchSelection)
      let hasOldAccount = false
      this.batchSelection.forEach(item => {
        if (item.clMargin.subsidiaryAccount.indexOf('955088000') > -1) {
          hasOldAccount = true
        }
      })
      if (hasOldAccount) {
        this.$Message.error('包含旧版保证金账号（已作废），不可进行线上退保操作')
        return
      }
      this.batchRefundVisible = true
    },
    selectionChange(selection) {
      this.batchSelection = selection
    },
    batchRefundConfirm() {
      if (!this.onlinePermission) {
        this.$Message.error('无权限')
        return
      }
      let hasOldAccount = false
      this.batchSelection.forEach(item => {
        if (item.clMargin.subsidiaryAccount.indexOf('955088000') > -1) {
          hasOldAccount = true
        }
      })
      if (hasOldAccount) {
        this.$Message.error('包含旧版保证金账号（已作废），不可进行线上退保操作')
        return
      }
      this.$Modal.confirm({
        title: '发起批量线上退款',
        content: '确认发起批量线上退款，发起退款后款项直接退还，请仔细确认',
        onOk: async () => {
          this.$Spin.show()
          try {
            let batchRefunds = []
            let batchOrders = []
            this.batchSelection.forEach(deposit => {
              batchRefunds.push({
                id: deposit.abpRefundMarginId,
                accountName: deposit.clMargin.ghfAccountName,
                bankName: deposit.clMargin.reciprocalOpenAccount,
                bankAccount: deposit.clMargin.ghfAccount,
                isInterest: deposit.isInterest,
                refundType: deposit.refundType,
                projectId: deposit.projectId,
                marginDetailId: deposit.clMarginId,
                ordersId: deposit.id,
                companyName: deposit.ghfCompanyName
              })
              batchOrders.push(deposit.id)
            })
            let rep = await ajax.post(requestUrls.AbpRefundMargin.GfCreateOrUpdateList, batchRefunds)
            if (rep.data.success) {
              // 发起退款
              await unlimitedAjax.post(requestUrls.ClMargin.MarginRefundList, batchOrders)
              this.$Spin.hide()
              this.$Message.success('已发起退款')
              this.batchRefundVisible = false
              this.getOrders(this.currentPage, this.searchValue)
            } else {
              this.$Spin.hide()
              this.$Message.error('发起退款失败')
              this.batchRefundVisible = false
            }
          } catch(err) {
            this.$Spin.hide()
            this.$Message.error('发起退款失败')
            console.error(err)
            this.batchRefundVisible = false
          }
        }
      })
    }
  },
  components: {
    invoice,
    Tooltip,
    Icon
  }
}
</script>

<style lang="less">
#order-management {
  .search-wrapper {
    margin: 5px;
    .search {
      display: inline-block;
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .ivu-modal {
    top: 30px;
  }
}

.redinvoice-item {
  padding: 5px;
}
.refund-modal {
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    color: #000;
  }
  .ivu-select-disabled .ivu-select-selection {
    color: #000;
  }
}
.batch-refund {
  .batch-item {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 8px;
  }
  .batch-item + .batch-item {
    margin-top: 16px;
  }
}
</style>
